module.exports = __webpack_public_path__ + "img/tl.859afa69.svg";